import {
  setAccount,
  setBkashAccount,
  setTransactionId,
  stepNext,
} from "../../redux/payment/slice";
import { PAYMENT_TYPES } from "../../types/PaymentMethodsTypes";

// Paykassma
export const dispatchTransactionStatus = (dispatch, data) => {
  if (data?.params?.account_type) {
    dispatch(setBkashAccount(data.params.account_type));
  }
  if (data?.transactionId) {
    dispatch(setTransactionId(data.transactionId));
  }
  if (data?.params?.identifier) {
    dispatch(setAccount(data.params.identifier));
    dispatch(stepNext(PAYMENT_TYPES.DEPOSIT));
  }
  if (data?.upiAddress) {
    dispatch(setAccount(data.upiAddress));
    dispatch(stepNext(PAYMENT_TYPES.DEPOSIT));
  }
};
